var flex = {
  "display": "flex !important"
};

export { flex };
